module.exports = __webpack_public_path__ + "static/media/skills.c4434ea4.svg";